import Component from "@ember/component"
import { computed } from "@ember/object"
import styles from "./toggle.module.css"

export default class DSToggle extends Component {
  readonly styles = styles
  isOn!: boolean
  onToggle!: Function
  color!: string

  @computed("isOn", "color")
  get activeColor(): string | undefined {
    return this.isOn ? this.color : undefined
  }
}
